import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch } from "vue";
import type { FormInstance } from "vant";
import { Row, Col, Field, Popup, Picker, Form } from "vant";
import CustomField from "../../../components/checkstand/CustomField.vue";
import { country, CA, US } from "@/assets/data/list";
import { getOrder } from "../../../tools/checkstand/checkstandOrder";


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingAddress',
  setup(__props, { expose }) {

const { order, addressRules } = getOrder();

// country
const countryArr: string[] = [];
const countryMap: { [props: string]: string } = {};
const countryMapRe: { [props: string]: string } = {};
country.forEach((c) => {
  countryArr.push(c.label);
  countryMap[c.label] = c.value;
  countryMapRe[c.value] = c.label;
});

const curCountry = ref("");
const countryList = countryArr;
const countryVisible = ref(false);
function onConfirmCountry(value: string) {
  order.Country = countryMap[value];
  countryVisible.value = false;
}

watch(
  () => order.Country,
  (now) => {
    curCountry.value = countryMapRe[now];
    if (now === "US") {
      const x = US.find((item) => item.value === order.State);
      if (!x) order.State = "";
    }
    if (now === "CA") {
      const x = CA.find((item) => item.value === order.State);
      if (!x) order.State = "";
    }
  }
);

const isCAxUS = computed(() => {
  return order.Country === "US" || order.Country === "CA";
});

const stateVisible = ref(false);
const stateList = computed(() => {
  if (order.Country == "CA") return CA.map((s) => s.value);
  if (order.Country == "US") return US.map((s) => s.value);
  return [];
});
function onConfirmState(value: string) {
  order.State = value;
  stateVisible.value = false;
}

const form = ref<FormInstance>();
expose({
  form,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Form), {
    class: "billing-address",
    ref_key: "form",
    ref: form
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("Country/Region:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Row), {
        type: "flex",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Col), { span: "16" }, {
            default: _withCtx(() => [
              _createVNode(CustomField, {
                value: curCountry.value,
                onCustomClick: _cache[0] || (_cache[0] = ($event: any) => (countryVisible.value = true)),
                rules: _unref(addressRules).CountryShow
              }, null, 8, ["value", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Col), { span: "7" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Field), {
                class: "field",
                name: "Country",
                readonly: "",
                "model-value": _unref(order).Country
              }, null, 8, ["model-value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(Popup), {
        show: countryVisible.value,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((countryVisible).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Picker), {
            "show-toolbar": "",
            columns: _unref(countryList),
            onConfirm: onConfirmCountry,
            "confirm-button-text": "confirm",
            "cancel-button-text": "cancel",
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (countryVisible.value = false))
          }, null, 8, ["columns"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("BillingAddress:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        modelValue: _unref(order).Address,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(order).Address) = $event)),
        name: "Address",
        rules: _unref(addressRules).Address
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("BillingCity:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        modelValue: _unref(order).City,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(order).City) = $event)),
        name: "City",
        rules: _unref(addressRules).City
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("BillingState:")
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(CustomField, {
        value: _unref(order).State,
        onCustomClick: _cache[5] || (_cache[5] = ($event: any) => (stateVisible.value = true)),
        rules: _unref(addressRules).State
      }, null, 8, ["value", "rules"]), [
        [_vShow, _unref(isCAxUS)]
      ]),
      _withDirectives(_createVNode(_unref(Field), {
        class: "field",
        name: "State",
        modelValue: _unref(order).State,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(order).State) = $event)),
        rules: _unref(addressRules).State
      }, null, 8, ["modelValue", "rules"]), [
        [_vShow, !_unref(isCAxUS)]
      ]),
      _createVNode(_unref(Popup), {
        show: stateVisible.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((stateVisible).value = $event)),
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Picker), {
            "show-toolbar": "",
            columns: _unref(stateList),
            onConfirm: onConfirmState,
            "confirm-button-text": "confirm",
            "cancel-button-text": "cancel",
            onCancel: _cache[7] || (_cache[7] = ($event: any) => (stateVisible.value = false))
          }, null, 8, ["columns"])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("Zip(Postal)/Code:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        name: "Zip",
        modelValue: _unref(order).Zip,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(order).Zip) = $event)),
        rules: _unref(addressRules).Zip
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("Email:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        name: "Email",
        modelValue: _unref(order).Email,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(order).Email) = $event)),
        rules: _unref(addressRules).Email
      }, null, 8, ["modelValue", "rules"]),
      _createVNode(_unref(Row), { class: "h3" }, {
        default: _withCtx(() => [
          _createTextVNode("Phone:")
        ]),
        _: 1
      }),
      _createVNode(_unref(Field), {
        class: "field",
        name: "Phone",
        modelValue: _unref(order).Phone,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(order).Phone) = $event)),
        rules: _unref(addressRules).Phone
      }, null, 8, ["modelValue", "rules"])
    ]),
    _: 1
  }, 512))
}
}

})